import { Autocomplete, FormControl, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { Button } from 'antd';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import Pagination from 'base/ui/components/Pagination/pagination';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiFillEye, AiOutlineDownload } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import { HiSearch } from 'react-icons/hi';
import { MdOutlineClose } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { ListStatusProduct } from 'services/commonDate_services';
import { CategoryModel } from 'services/listCategory_services';
import { ProductModelDetail } from 'services/product_services';
import * as rootStore from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { SearchModel } from './models';
import { formatNumber } from 'utils/formatHelper';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';

export function createProduct() {
  return observer(() => {
    const navigate = useNavigate();
    useCheckPermission("INDEX")

    const Style = {
      '.MuiOutlinedInput-root': {
        padding: 0,
        borderRadius: 0,
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
        fontSize: '13px',
      },
    };

    const isEdit = checkPermission('EDIT')

    // =================== SET STATE ==========================//
    const [actived, setActived] = useState('true');
    const [expiredDate, setExpiredDate] = useState('');
    const [tooManyTime, setTooManyTime] = useState('');
    const [status, setStatus] = useState('');
    // số lượng items trên 1 trang
    const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
    // current page
    const [pageIndex, setPageIndex] = useState(1);

    // const [productSearch, setProductSearch] = useState<ProductModelDetail>({
    //   productCode: '',
    //   productName: '',
    //   categoryId: null,
    //   parentCategoryId: null,
    //   categoryDetailId: null,
    //   hasRouting: null,
    //   actived: null,
    // });

    // show many input field
    const [isShow, setIsShow] = useState(false);

    // kiểu dáng sản phẩm
    const [styleCategory, setStyleCategory] = useState<CategoryModel[]>([])

    // danh sách phan cap san pham
    const [parentCategory, setParentCategory] = useState<CategoryModel[]>([]);
    // danh sach nhom san pham
    const [category, setCategory] = useState<CategoryModel[]>([]);
    // danh sách nhom san pham chi tiet
    const [categoryDetail, setCategoryDetail] = useState<CategoryModel[]>([]);
    // danh sách status
    const [listStatus, setListStatus] = useState<ListStatusProduct[]>([]);
    // =======  LIST (get id from list )===============
    const [parentCategoryId, setParentCategoryId] = useState<CategoryModel | null>(null);
    const [categoryId, setCategoryId] = useState<CategoryModel | undefined>(undefined);
    const [categoryDetailId, setCategoryDetailId] = useState<CategoryModel | null>(null);
    const [categoryDetail2Id, setCategoryDetail2Id] = useState<CategoryModel | null>(null);
    // Drop down autocomplete bin
    const [listDropdownBin, setListDropdownBin] = useState<CategoryModel[]>([]);
    // Drop down autocomplete current bin
    const [listDropdownCurrentBin, setListDropdownCurrentBin] = useState<CategoryModel[]>([]);

    const [isLoading, setIsLoading] = useState(true);
    // ======== Keyword ===============================
    const [keyWordParentCategory, setKeyWordParentCategory] = useState('');
    const [keyWordCategory, setKeyWordCategory] = useState('');
    const [keyWordCategoryDetail, setKeyWordCategoryDetail] = useState('');
    const [keyWordCategory2Detail, setKeyWordCategory2Detail] = useState('');
    // bin
    const [bin, setBin] = useState(rootStore.productStore.productSearch.bin);
    // Current bin
    const [currentBin, setCurrentBin] = useState(rootStore.productStore.productSearch.currentBin);

    // loading khi search
    const [searchLoading, setSearchLoading] = useState(false);
    // Thông tin tìm kiếm , phân trang và sort
    // const [search, setSearch] = useState<SearchModel>({
    //   paging: {
    //     pageSize: PAGE_SIZE_DEFAULT,
    //     pageIndex: 1,
    //     orderByDesc: '',
    //     orderBy: '',
    //   },
    //   productCode: '',
    //   productName: '',
    //   categoryId: '',
    //   parentCategoryId: '',
    //   categoryDetailId: '',
    //   hasRouting: true,
    //   actived: true,
    //   statusMold: '',
    //   isExpiredDate: true,
    //   isTooManyTimes: true,
    //   bin: '',
    //   currentBin: '',
    // });
    // =============================FUNCTION===========================================
    // các row trong table lấy từ store
    const tableRows = rootStore.productStore.product.data;
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<ProductModelDetail>();

    // const handleChangeRouting = async (event: SelectChangeEvent) => {
    //   // setRouting(event.target.value);
    //   await rootStore.productPresenter.setSearchState(rootStore.productStore, {
    //     ...rootStore.productStore.productSearch,
    //     hasRouting: JSON.parse(event.target.value.toLowerCase()),
    //   });
    // };

    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      { columnName: 'Mã phân cấp', align: 'text-center', visible: true },

      { columnName: 'Mã nhóm sản phẩm', align: 'text-center', visible: true },

      {
        columnName: 'Mã nhóm sản phẩm chi tiết',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Kiểu dáng sản phẩm',
        align: 'text-center',
        visible: true,
      },

      { columnName: 'Mã TP/BTP', align: 'text-center', visible: true },
      { columnName: 'Tên TP/BTP', align: 'text-center', visible: true },
      { columnName: 'Serial', align: 'text-center', visible: true },
      {
        columnName: 'Default Bin',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Current Bin',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Tình trạng khuôn',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Mã film kiểm tra',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Mã film chụp bản',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Kho khuôn',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Kích thước / Quy cách',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Kích thước / Quy cách SP',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Loại dao',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Loại máy bế',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Số SP/ Khuôn',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Tên nhà cung cấp',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Mã cũ',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Thử nghiệm khuôn',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Số lượng dập lũy kế',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Số lượng dập hiện tại',
        align: 'text-center',
        visible: isShow,
      },
      {
        columnName: 'Ghi chú',
        align: 'text-center',
        visible: true,
      },
      { columnName: 'Trạng thái', align: 'text-center', visible: true },
      {
        columnName: 'Chức năng',
        align: 'text-center',
        visible: true,
      },
    ];
    //-----LẤY DATA DROPDOWN BIN-------------------------------------------------------------------------------- //
    const getDataDropdownBin = async (dataSearch = bin) => {
      await rootStore.commonDatePresenter.getDropdownBin(rootStore.commonDateStore, dataSearch);
      if (rootStore.commonDateStore.listStatusProductResponse.isSuccess) {
        setListDropdownBin(rootStore.commonDateStore.listStatusProductResponse.data);
      }
    };
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----LẤY DATA DROPDOWN CURRENT BIN------------------------------------------------------------------------ //
    const getDataDropdownCurrentBin = async (dataSearch = currentBin) => {
      await rootStore.commonDatePresenter.getDropdownCurrentBin(rootStore.commonDateStore, dataSearch);
      if (rootStore.commonDateStore.listStatusProductResponse.isSuccess) {
        setListDropdownCurrentBin([
          { key: 'Trong', value: 'Trống' },
          ...rootStore.commonDateStore.listStatusProductResponse.data,
        ]);
      }
    };
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //

    const handleChangeActived = (event: SelectChangeEvent) => {
      setActived(event.target.value);
      rootStore.productPresenter.setSearchState(rootStore.productStore, {
        ...rootStore.productStore.productSearch,
        actived: JSON.parse(event.target.value.toLowerCase()),
      });
    };
    const handleChangeExpireDate = (event: SelectChangeEvent) => {
      setExpiredDate(event.target.value);
      rootStore.productPresenter.setSearchState(rootStore.productStore, {
        ...rootStore.productStore.productSearch,
        isExpiredDate: JSON.parse(event.target.value.toLowerCase()),
      });
    };
    const handleChangeTooManyTimes = (event: SelectChangeEvent) => {
      setTooManyTime(event.target.value);
      rootStore.productPresenter.setSearchState(rootStore.productStore, {
        ...rootStore.productStore.productSearch,
        isTooManyTimes: JSON.parse(event.target.value.toLowerCase()),
      });
    };
    const handleCheck = (value: string) => {
      if (value === actived) {
        setActived('');
      } else {
        setActived(value);
      }
    };
    const handleCheckExpireDate = (value: string) => {
      if (value === expiredDate) {
        setExpiredDate('');
      } else {
        setExpiredDate(value);
      }
    };
    const handleCheckTooManyTime = (value: string) => {
      if (value === tooManyTime) {
        setTooManyTime('');
      } else {
        setTooManyTime(value);
      }
    };
    const handleChangeStatus = (event: SelectChangeEvent) => {
      const statusValue = event.target.value;
      setStatus(statusValue);
      rootStore.productPresenter.setSearchState(rootStore.productStore, {
        ...rootStore.productStore.productSearch,
        statusMold: statusValue,
      });
    };

    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageSize(parseInt(e.target.value));
    };
    const handleChangePageIndex = (data: any) => {
      setPageIndex(data.selected + 1);
    };

    //=========== get value from Autocomplete (parentCate, cate, cateDetail)
    // phân cấp sản phẩm
    const handleChangeParentCategory = async (e: React.SyntheticEvent<Element, Event>, value: CategoryModel | null) => {
      if (value) {
        setParentCategoryId({
          key: value.key,
          value: value.value,
        });
        setCategoryId(undefined)
        setCategoryDetailId(null)
        // kiểm tra value để hiển thị thêm ô inputawait rootStore.productPresenter.getListCategory(rootStore.productStore, '', '', 1);
        setParentCategory(rootStore.productStore.listParentCategory.data);
        // nếu là 32 khuôn thì cho search tình trạng khuôn và bảo trì khuôn
        if (value.value === '32-Khuôn') {
          setIsShow(true);
          // nếu không phải 32 khuôn thì ẩn
        } else {
          setIsShow(false);
        }

        // call api nhóm sản phẩm
        await rootStore.productPresenter.getListCategory(rootStore.productStore, '', value.key, '', 2);
        if (rootStore.productStore.listCategory.isSuccess) {
          setCategory(rootStore.productStore.listCategory.data);
        }
        // call api nhóm sản phẩm chi tiết
        // await rootStore.productPresenter.getListCategory(rootStore.productStore, '', value.key, '', 3);
        // if (rootStore.productStore.listCategoryDetail.isSuccess) {
        //   setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
        // }
      } else {
        setCategoryId(undefined);
        setParentCategoryId(null);
        setCategoryDetailId(null)
        // call api nhóm sản phẩm
        await rootStore.productPresenter.getListCategory(rootStore.productStore, '', '', '', 2);
        if (rootStore.productStore.listCategory.isSuccess) {
          setCategory(rootStore.productStore.listCategory.data);
        }
        await rootStore.productPresenter.getListCategory(rootStore.productStore, '', '', '', 3);
        if (rootStore.productStore.listCategoryDetail.isSuccess) {
          setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
        }
        await rootStore.productPresenter.getListCategory(rootStore.productStore, '', '', '', 4);
        if (rootStore.productStore.listCategory2Detail.isSuccess) {
          setStyleCategory(rootStore.productStore.listCategory2Detail.data);
        }
        // nếu không có text trong ô input thì ẩn
        setIsShow(false);
      }
    };

    // Nhóm sản phẩm chi tiết
    const handleChangeCategoryDetail = async (e: React.SyntheticEvent<Element, Event>, option: CategoryModel | null) => {
      if (option) {
        setCategoryDetail2Id(null)
        setCategoryDetailId({ value: option.value, key: option.key });
        // call api kiểu dáng sản phẩm
        await rootStore.productPresenter.getListCategory(
          rootStore.productStore,
          '',
          option.key,
          '',
          4,
        );
        if (rootStore.productStore.listCategory2Detail.isSuccess) {
          setStyleCategory(rootStore.productStore.listCategory2Detail.data);
        }
      } else {
        setCategoryDetailId(null);
        await rootStore.productPresenter.getListCategory(
          rootStore.productStore,
          '',
          "",
          '',
          4,
        );
        if (rootStore.productStore.listCategory2Detail.isSuccess) {
          setStyleCategory(rootStore.productStore.listCategory2Detail.data);
        }
      }
    };
    // kiểu dáng sản phẩm
    const handleChangeCategory2Detail = (e: React.SyntheticEvent<Element, Event>, option: CategoryModel | null) => {
      if (option) {
        setCategoryDetail2Id({ value: option.value, key: option.key });
      } else {
        setCategoryDetail2Id(null);
      }
    };
    // Nhóm sản phẩm
    const handleChangeCategory = async (e: React.SyntheticEvent<Element, Event>, option: CategoryModel | null) => {
      if (option) {
        setCategoryDetailId(null)
        setCategoryId({ key: option.key, value: option.value });
        // call api nhóm sản phẩm chi tiết
        await rootStore.productPresenter.getListCategory(
          rootStore.productStore,
          '',
          option.key,
          '',
          3,
        );
        if (rootStore.productStore.listCategoryDetail.isSuccess) {
          setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
        }
      } else {
        setCategoryId(undefined);
        await rootStore.productPresenter.getListCategory(
          rootStore.productStore,
          '',
          "",
          '',
          3,
        );
        if (rootStore.productStore.listCategoryDetail.isSuccess) {
          setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
        }
      }
    };

    // =========== get keyword category
    const handleChangeKeyWordParentCategory = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeyWordParentCategory(e.target.value);
      await rootStore.productPresenter.getListCategory(rootStore.productStore, e.target.value, '', '', 1);
      setParentCategory(rootStore.productStore.listParentCategory.data);
    };
    const handleChangeKeyWordCategory = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeyWordCategory(e.target.value);
      await rootStore.productPresenter.getListCategory(rootStore.productStore, e.target.value, parentCategoryId ? parentCategoryId.key : '', '', 2);
      setCategory(rootStore.productStore.listCategory.data);
    };
    const handleChangeKeyWordCategoryDetail = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeyWordCategoryDetail(e.target.value);
      await rootStore.productPresenter.getListCategory(rootStore.productStore, e.target.value, categoryId ? categoryId.key : '', '', 3);
      setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
    };
    const handleChangeKeyWordCategory2Detail = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeyWordCategory2Detail(e.target.value);
      await rootStore.productPresenter.getListCategory(rootStore.productStore, e.target.value, categoryDetailId ? categoryDetailId.key : '', '', 4);
      setStyleCategory(rootStore.productStore.listCategory2Detail.data);
    };

    //===============hàm xử lý bin
    // bắt sự thay đổi khi chọn option
    const handleChangBin = async (e: React.SyntheticEvent<Element, Event>, value: string) => {
      setBin(value);
    };
    // xử lý thay đổi keyword
    const handleChangeBinKeyword = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      await getDataDropdownBin(e.target.value);
      setBin(e.target.value);
    };
    //===============hàm xử lý curent bin
    // bắt sự thay đổi khi chọn option
    const handleChangCurrentBin = async (e: React.SyntheticEvent<Element, Event>, value: string) => {
      setCurrentBin(value);
    };
    // xử lý thay đổi keyword
    const handleChangeCurrentBinKeyword = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      await getDataDropdownCurrentBin(e.target.value);
      setCurrentBin(e.target.value);
    };

    // =========== SEARCH ==========================
    const onSearch = async (data: ProductModelDetail) => {
      setIsLoading(true);
      await rootStore.productPresenter.setSearchState(rootStore.productStore, {
        ...rootStore.productStore.productSearch,
        productCode: data.productCode,
        productName: data.productName,
        categoryId: categoryId ? categoryId.key : null,
        parentCategoryId: parentCategoryId?.key || null,
        parentCategory: parentCategoryId,
        categoryDetailId: categoryDetailId?.key || null,
        categoryDetail2Id: categoryDetail2Id?.key || null,
        actived: actived === '' ? null : rootStore.productStore.productSearch.actived,
        // statusMold: rootStore.productStore.productSearch.statusMold,
        statusMold: status,
        isExpiredDate: expiredDate === '' ? null : rootStore.productStore.productSearch.isExpiredDate,
        isTooManyTimes: tooManyTime === '' ? null : rootStore.productStore.productSearch.isTooManyTimes,
        bin: bin,
        currentBin: currentBin,
      });

      await rootStore.productPresenter.getListProduct(rootStore.productStore, {
        paging: {
          pageIndex: 1,
          pageSize: pageSize,
        },
        productCode: data.productCode,
        productName: data.productName,
        parentCategoryId: parentCategoryId?.key || null,
        categoryId: categoryId ? categoryId.key : null,
        categoryDetailId: categoryDetailId?.key,
        categoryDetail2Id: categoryDetail2Id?.key,
        hasRouting: rootStore.productStore.productSearch.hasRouting,
        actived: rootStore.productStore.productSearch.actived,
        statusMold: status,
        isExpiredDate: rootStore.productStore.productSearch.isExpiredDate,
        isTooManyTimes: rootStore.productStore.productSearch.isTooManyTimes,
        bin: bin,
        currentBin: currentBin,
      });
      setPageIndex(1);
      setIsLoading(false);
    };

    // =========== USE EFFECT =======================
    useEffect(() => {
      setIsLoading(true);
      const getListProduct = async () => {
        await rootStore.productPresenter.getListProduct(rootStore.productStore, {
          paging: {
            pageIndex: 1,
            pageSize: pageSize,
          },
          productCode: rootStore.productStore.productSearch.productCode,
          productName: rootStore.productStore.productSearch.productName,
          categoryId: rootStore.productStore.productSearch.categoryId,
          parentCategoryId: rootStore.productStore.productSearch.parentCategoryId,
          categoryDetailId: rootStore.productStore.productSearch.categoryDetailId,
          categoryDetail2Id: rootStore.productStore.productSearch.categoryDetail2Id,
          hasRouting: rootStore.productStore.productSearch.hasRouting,
          actived: rootStore.productStore.productSearch.actived,
          statusMold: rootStore.productStore.productSearch.statusMold,
          isExpiredDate: rootStore.productStore.productSearch.isExpiredDate,
          isTooManyTimes: rootStore.productStore.productSearch.isTooManyTimes,
          bin: bin,
          currentBin: currentBin,
        });
        setIsLoading(false);
      };

      const getListStatusProduct = async () => {
        await rootStore.commonDatePresenter.getListStatusProduct(rootStore.commonDateStore);
        setListStatus(rootStore.commonDateStore.listStatusProductResponse.data);
      };

      setPageIndex(1);
      getListProduct();
      getListStatusProduct();
    }, [pageSize]);

    useEffect(() => {
      setIsLoading(true);
      // phân cấp sản phẩm
      const getParentCategory = async () => {
        await rootStore.productPresenter.getListCategory(rootStore.productStore, keyWordParentCategory, '', '', 1);
        setParentCategory(rootStore.productStore.listParentCategory.data);
      };
      // nhóm sản phẩm
      const getCategory = async () => {
        await rootStore.productPresenter.getListCategory(rootStore.productStore, keyWordCategory, '', '', 2);
        setCategory(rootStore.productStore.listCategory.data);
      };
      // nhóm sản phẩm chi tiết
      const getParentCategoryDetail = async () => {
        await rootStore.productPresenter.getListCategory(rootStore.productStore, keyWordCategoryDetail, null, null, 3);
        setCategoryDetail(rootStore.productStore.listCategoryDetail.data);
      };
      // kiểu dáng sản phẩm
      const getParentCategory2Detail = async () => {
        await rootStore.productPresenter.getListCategory(rootStore.productStore, keyWordCategory2Detail, null, null, 4);
        setStyleCategory(rootStore.productStore.listCategory2Detail.data);
      };
      const doInit = async () => {
        await getParentCategory();
        await getCategory();
        await getParentCategoryDetail();
        await getParentCategory2Detail();
        await getDataDropdownBin();
        await getDataDropdownCurrentBin();
        setIsLoading(false);
      };
      doInit();
    }, []);

    useEffect(() => {
      setIsLoading(true);
      const getListProduct = async () => {
        await rootStore.productPresenter.getListProduct(rootStore.productStore, {
          paging: {
            pageIndex: pageIndex,
            pageSize: pageSize,
          },
          productCode: rootStore.productStore.productSearch.productCode,
          productName: rootStore.productStore.productSearch.productName,
          categoryId: rootStore.productStore.productSearch.categoryId,
          parentCategoryId: rootStore.productStore.productSearch.parentCategoryId,
          categoryDetailId: rootStore.productStore.productSearch.categoryDetailId,
          categoryDetail2Id: rootStore.productStore.productSearch.categoryDetail2Id,
          hasRouting: rootStore.productStore.productSearch.hasRouting,
          actived: rootStore.productStore.productSearch.actived,
          statusMold: rootStore.productStore.productSearch.statusMold,
          isExpiredDate: rootStore.productStore.productSearch.isExpiredDate,
          isTooManyTimes: rootStore.productStore.productSearch.isTooManyTimes,
          bin: bin,
          currentBin: currentBin,
        });
        setIsLoading(false);
      };
      getListProduct();
    }, [pageIndex]);

    return (
      <div className="w-full py-3 px-5">
        {isLoading && <LoadingScreen />}
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-bold text-gray-800 uppercase">THÔNG TIN SẢN PHẨM</h3>
          <Button
            size="middle"
            loading={searchLoading}
            className="bg-blue-500 !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
            onClick={async (data: any) => {
              setSearchLoading(true);
              await rootStore.productPresenter.exportExcelProduct({
                ...rootStore.productStore.productSearch,
                productCode: data.productCode,
                productName: data.productName,
                categoryId: categoryId ? categoryId.key : null,
                parentCategoryId: parentCategoryId?.key || null,
                parentCategory: parentCategoryId,
                categoryDetailId: categoryDetailId?.key,
                categoryDetail2Id: categoryDetail2Id?.key,
                actived: actived === '' ? null : rootStore.productStore.productSearch.actived,
                // statusMold: rootStore.productStore.productSearch.statusMold,
                statusMold: status,
                isExpiredDate: expiredDate === '' ? null : rootStore.productStore.productSearch.isExpiredDate,
                isTooManyTimes: tooManyTime === '' ? null : rootStore.productStore.productSearch.isTooManyTimes,
                bin: bin,
                currentBin: currentBin,
              });
              setSearchLoading(false);
            }}
            type="primary"
          >
            <AiOutlineDownload className="block text-base" />
            <span className="block">Export Excel</span>
          </Button>
        </div>

        {/* Form nhập tìm kiếm */}
        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full lg:grid lg:grid-cols-2 flex flex-col gap-2">
            {/* Mã TP/BTP*/}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Mã TP/BTP
              </label>
              <input
                {...register('productCode')}
                defaultValue={rootStore.productStore.productSearch.productCode}
                className="col-span-3 sm:col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* tên TP/BTP */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Tên TP/BTP
              </label>
              <input
                {...register('productName')}
                type="text"
                defaultValue={rootStore.productStore.productSearch.productName}
                className="col-span-3 sm:col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* phân cấp sản phẩm  */}
            <div className="w-full  sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Phân cấp sản phẩm
              </label>
              <Autocomplete
                // {...register('parentCategoryId')}
                className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="parentCategoryId"
                options={parentCategory}
                sx={Style}
                classes={{ listbox: 'text-default' }}
                filterOptions={(options, state) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField onChange={handleChangeKeyWordParentCategory} {...params} />}
                onChange={handleChangeParentCategory}
              />
            </div>
            {/* Nhóm sản phẩm */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Nhóm sản phẩm
              </label>
              <Autocomplete
                className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none !rounded-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={category}
                sx={Style}
                value={categoryId || null}
                classes={{ listbox: 'text-default' }}
                onChange={handleChangeCategory}
                filterOptions={(options) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField onChange={handleChangeKeyWordCategory} {...params} />}
              />
            </div>
            {/* Nhóm sản phẩm chi tiết*/}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Nhóm sản phẩm chi tiết
              </label>
              <Autocomplete
                className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none !rounded-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={categoryDetail}
                onChange={handleChangeCategoryDetail}
                sx={Style}
                value={categoryDetailId}
                classes={{ listbox: 'text-default' }}
                filterOptions={(options) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField onChange={handleChangeKeyWordCategoryDetail} {...params} />}
              />
            </div>
            {/* Kiểu dáng sản phẩm */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Kiểu dáng sản phẩm
              </label>
              <Autocomplete
                className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none !rounded-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={styleCategory}
                onChange={handleChangeCategory2Detail}
                sx={Style}
                value={categoryDetail2Id}
                classes={{ listbox: 'text-default' }}
                filterOptions={(options) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField onChange={handleChangeKeyWordCategory2Detail} {...params} />}
              />
            </div>
            {/* trạng thái*/}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Trạng thái
              </label>
              <div className="col-span-3 sm:col-span-2 sm:ml-5 py-1.5 text-default grid grid-cols-2">
                <div className="mr-5 flex items-center">
                  <input
                    id="active"
                    onChange={handleChangeActived}
                    type="radio"
                    name="actived"
                    checked={actived === 'true'}
                    onClick={() => handleCheck('true')}
                    value={'true'}
                    className="mr-2"
                  />
                  <label htmlFor="active">Đang sử dụng</label>
                </div>

                <div className="mr-5 flex items-center">
                  <input
                    id="unactive"
                    onChange={handleChangeActived}
                    onClick={() => handleCheck('false')}
                    type="radio"
                    checked={actived === 'false'}
                    name="actived"
                    className="mr-2"
                    value={'false'}
                    readOnly
                  />
                  <label htmlFor="unactive">Ngưng sử dụng</label>
                </div>
              </div>
            </div>

            {/* Tình trạng khuôn*/}
            {isShow && (
              <div className="w-full sm:items-center grid grid-cols-3">
                <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                  Tình trạng khuôn
                </label>
                <FormControl className="col-span-3 sm:col-span-2">
                  <Select
                    {...register('statusMold')}
                    value={status}
                    // value={
                    //   rootStore.productStore.productSearch.statusMold &&
                    //   rootStore.productStore.productSearch.statusMold
                    // }
                    className="text-gray-700 hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    onChange={handleChangeStatus}
                    displayEmpty
                    sx={{ height: 35 }}
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem value="">
                      <span className="text-default">-- Tất cả --</span>
                    </MenuItem>
                    {listStatus.map((item, index) => (
                      <MenuItem value={item.key} key={index}>
                        <span className="text-default">{item.value}</span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}
            {/* Quá số ngày */}
            {isShow && (
              <>
                <div className="w-full sm:items-center  grid grid-cols-3">
                  <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                    Quá số ngày
                  </label>
                  <div className="col-span-3 sm:col-span-2 grid sm:ml-5 py-1.5 text-default grid-cols-3">
                    <div className="mr-5 flex items-center">
                      <input
                        id="expireddate"
                        type="radio"
                        name="expireddate"
                        onChange={handleChangeExpireDate}
                        checked={expiredDate === 'true'}
                        onClick={() => handleCheckExpireDate('true')}
                        value={'true'}
                        className="mr-2"
                      />
                      <label htmlFor="expireddate">Có</label>
                    </div>

                    <div className="mr-5 flex items-center">
                      <input
                        id="unexpireddate"
                        type="radio"
                        name="expireddate"
                        checked={expiredDate === 'false'}
                        onChange={handleChangeExpireDate}
                        onClick={() => handleCheckExpireDate('false')}
                        className="mr-2"
                        value={'false'}
                        readOnly
                      />
                      <label htmlFor="unexpireddate">Không</label>
                    </div>
                  </div>
                </div>
                {/* Default Bin */}
                <div className="w-full sm:items-center grid grid-cols-3">
                  <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                    Default Bin
                  </label>
                  <Autocomplete
                    freeSolo
                    disableClearable
                    className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none !rounded-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="disabled-options-demo"
                    options={listDropdownBin.map((option) => option.value)}
                    onChange={(e, value) => handleChangBin(e, value)}
                    sx={Style}
                    classes={{ listbox: 'text-default' }}
                    filterOptions={(options, state) => options}
                    defaultValue={rootStore.productStore.productSearch.bin}
                    renderInput={(params) => <TextField onChange={handleChangeBinKeyword} {...params} />}
                  />
                </div>
                {/* Quá số lần dập */}
                <div className="w-full sm:items-center grid grid-cols-3">
                  <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                    Quá số lần dập
                  </label>
                  <div className="col-span-3 sm:col-span-2 grid sm:ml-5 py-1.5 text-default grid-cols-3">
                    <div className="mr-5 flex items-center">
                      <input
                        id="toomanytime"
                        type="radio"
                        name="isTooManyTimes"
                        onChange={handleChangeTooManyTimes}
                        checked={tooManyTime === 'true'}
                        onClick={() => handleCheckTooManyTime('true')}
                        value={'true'}
                        className="mr-2"
                      />
                      <label htmlFor="toomanytime">Có</label>
                    </div>

                    <div className="mr-5 flex items-center">
                      <input
                        id="unTooManyTime"
                        type="radio"
                        name="isTooManyTimes"
                        onChange={handleChangeTooManyTimes}
                        checked={tooManyTime === 'false'}
                        onClick={() => handleCheckTooManyTime('false')}
                        className="mr-2"
                        value={'false'}
                        readOnly
                      />
                      <label htmlFor="unTooManyTime">Không</label>
                    </div>
                  </div>
                </div>
                {/* Current Bin */}
                <div className="w-full sm:items-center grid grid-cols-3">
                  <label className="col-span-3 sm:col-span-1 min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                    Current Bin
                  </label>
                  <Autocomplete
                    freeSolo
                    disableClearable
                    className="col-span-3 sm:col-span-2 text-gray-700 hover:ring-0 hover:outline-none !rounded-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="disabled-options-demo"
                    options={listDropdownCurrentBin.map((option) => option.value)}
                    onChange={(e, value) => handleChangCurrentBin(e, value)}
                    sx={Style}
                    classes={{ listbox: 'text-default' }}
                    filterOptions={(options, state) => options}
                    defaultValue={rootStore.productStore.productSearch.currentBin}
                    renderInput={(params) => <TextField onChange={handleChangeCurrentBinKeyword} {...params} />}
                  />
                </div>
              </>
            )}

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center mt-1 col-span-2">
              <button
                onClick={handleSubmit(onSearch)}
                type="submit"
                // onClick={handleSubmit(onSearch)}
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 text-center focus:outline-none hover:bg-blue-600`}
              >
                <>
                  <HiSearch className="font-bold text-lg" />
                  Tìm kiếm
                </>
              </button>
            </div>
          </form>
        </div>

        {/* Table product */}
        <div className="w-full bg-white py-3 px-5 rounded border border-neutral-300">
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={rootStore.productStore.product.pagesCount}
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />
          {/* =========== Table PO ===============*/}
          <div className={`overflow-x-auto my-3.5`}>
            <table className="w-full text-default table-auto border-collapse space-collapse text-default`">
              <thead className="font-medium text-gray-700 bg-gray-100">
                <tr>
                  {column?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <th
                          key={index}
                          scope="col"
                          className={`${item.visible ? '' : 'hidden'} py-2 px-5 border whitespace-nowrap text-left ${item.align
                            }`}
                        >
                          {item.columnName}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {tableRows?.map((row, index) => (
                  <tr className={`${index % 2 !== 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100`} key={row.stt}>
                    {/* Số thứ tự */}
                    <td className="border whitespace-nowrap text-center">{row.stt}</td>
                    {/* Mã phân cấp*/}
                    <td className="border whitespace-nowrap px-2 text-left">{row.parentCategoryName}</td>
                    {/* Mã nhóm sản phẩm */}
                    <td className=" border whitespace-nowrap px-2 text-left">{row.categoryName}</td>
                    {/* Mã nhóm sản phẩm Chi tiết*/}
                    <td className=" border whitespace-nowrap px-2 text-left">{row.categoryDetailName}</td>
                    {/* Kiểu dáng sản phẩm */}
                    <td className=" border whitespace-nowrap px-2 text-left">{row.categoryDetail2Name}</td>
                    {/* Mã TP/BTP*/}
                    <td className=" border whitespace-nowrap px-2 text-left">{row.productCode}</td>
                    {/* Tên TP/BTP*/}
                    <td
                      onClick={() => navigate(`productId=${row.productId}`)}
                      className="border cursor-pointer text-blue-800 hover:text-blue-800/80 whitespace-nowrap px-2 text-left"
                    >
                      {row.productName}
                    </td>
                    {/* Serial*/}
                    <td className="px-2 border whitespace-nowrap text-center">{row.serial}</td>
                    {/*default Bin*/}
                    <td className="px-2 border whitespace-nowrap">{row.bin}</td>
                    {/*curent Bin*/}
                    <td className="px-2 border whitespace-nowrap">{row.currentBin}</td>
                    {/* Tình Trạng khuôn */}
                    <td className="px-2 border whitespace-nowrap text-center" hidden={!isShow}>
                      {row.status}
                    </td>
                    {/* Mã film kiểm tra */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.printMoldFilm}
                    </td>
                    {/* Mã film chụp bản */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.printMoldName}
                    </td>
                    {/* Kho khuôn */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.sloc}
                    </td>
                    {/* Kích thước / Quy cách */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.specification}
                    </td>
                    {/* Kích thước / Quy cách SP */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.size}
                    </td>
                    {/* Loại Dao */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.knifeType}
                    </td>
                    {/* Loại Máy Bế */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.equipmentType}
                    </td>
                    {/* Số SP /Khuôn */}
                    <td className="px-2 border whitespace-nowrap text-right" hidden={!isShow}>
                      {row.productNum && formatNumber(Number(row.productNum), 0)}
                    </td>
                    {/* Tên nhà cung cấp  */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.vendor}
                    </td>
                    {/* Mã cũ */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.oldCode}
                    </td>
                    {/* Thử nghiệm khuôn */}
                    <td className="px-2 border whitespace-nowrap" hidden={!isShow}>
                      {row.moldTest}
                    </td>
                    {/* Số lượng dập lũy kế */}
                    <td className="px-2 border whitespace-nowrap text-right" hidden={!isShow}>
                      {row.stampQuantity && formatNumber(Number(row.stampQuantity), 0)}
                    </td>
                    {/* Số lượng dập hiện tại */}
                    <td className="px-2 border whitespace-nowrap text-right" hidden={!isShow}>
                      {row.currentStampQuantity && formatNumber(row.currentStampQuantity, 0)}
                    </td>
                    {/* ghi chú */}
                    <td
                      className="px-2 border whitespace-nowrap"
                    // hidden={!isShow}
                    >
                      {row.ghiChu}
                    </td>
                    {/* trạng thái*/}
                    <td className="px-2 border whitespace-nowrap text-center">
                      {row.actived ? (
                        <FaCheck className="text-blue-700 text-lg text-center mx-auto" />
                      ) : (
                        <MdOutlineClose className="text-red-800 font-extrabold text-[24px] mx-auto" />
                      )}
                    </td>
                    {/* chuc nang */}
                    <td className="py-1 px-2 border whitespace-nowrap flex justify-center gap-4">
                      {isEdit && <Link
                        // onClick={() => navigate(`Edit/productId=${row.productId}`)}
                        to={`Edit/productId=${row.productId}`}
                        className=" text-default bg-btn_edit py-0.25 rounded-base px-2.5 border-gray-300 border flex gap-1 items-center justify-center"
                      >
                        Sửa
                      </Link>}
                      <Link
                        to={`productId=${row.productId}`}
                        // onClick={() => navigate(`productId=${row.productId}`)}
                        className=" text-default bg-primary text-white py-0.25 rounded-base px-2.5  border-gray-300 border flex gap-1 items-center justify-center"
                      >
                        <AiFillEye />
                        <span>Xem chi tiết</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <span className="block text-default">
            Đang xem từ {`${tableRows && tableRows.length ? tableRows[0]?.stt : 0}`} đến {`${tableRows && tableRows.length ? tableRows[tableRows.length - 1]?.stt : 0}`} trong tổng số{' '}
            {`${rootStore.productStore.product.recordsTotal || 0}`} mục
          </span>
        </div>
      </div>
    );
  });
}
